<template>
  <div class="page_wrap">
    <div>
      <template v-if="$route.query.request">
        <div class="notification notification-notice" style="padding:10px 15px 35px 15px;">
          <div class="notification-inner">
            <span class="notification-icon"></span>
            <span class="notification-text">{{$t('homeRequestSuccessfulMessage')}}</span>
            <a @click="hideSuccessMessage" class="notification-dismiss" data-notification-dismiss></a>
          </div>
        </div>
      </template>
    </div>
    <component v-bind:is="headerComponent"></component>
    <div class="vpn_boxes_section">
      <ul class="category-boxes">

        <li @click="trackPageClick('using_sitename')" class="category-boxes__item">
          <router-link class="category-boxes__item__link" :to="{name: 'using-site'}">
            <svg class="icon" width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.6625 10.4531H21.4625V14.2531H17.6625V10.4531ZM17.6625 18.0531H21.4625V29.4531H17.6625V18.0531ZM19.5625 0.953125C9.0745 0.953125 0.5625 9.46513 0.5625 19.9531C0.5625 30.4411 9.0745 38.9531 19.5625 38.9531C30.0505 38.9531 38.5625 30.4411 38.5625 19.9531C38.5625 9.46513 30.0505 0.953125 19.5625 0.953125ZM19.5625 35.1531C11.1835 35.1531 4.3625 28.3321 4.3625 19.9531C4.3625 11.5741 11.1835 4.75312 19.5625 4.75312C27.9415 4.75312 34.7625 11.5741 34.7625 19.9531C34.7625 28.3321 27.9415 35.1531 19.5625 35.1531Z" fill="#3E3EFF"/>
            </svg>
            <h3 class="title">{{categories[getCategoryIdByName('using-site')].title}}</h3>
            <p class="text" v-html="categories[getCategoryIdByName('using-site')].body"></p>
          </router-link>
        </li>

        <li @click="trackPageClick('billing_support')" class="category-boxes__item">
          <router-link class="category-boxes__item__link" :to="{name: 'billing-support'}">
            <svg class="icon" width="48" height="39" viewBox="0 0 48 39" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M42.8731 0.953125H4.87305C2.2368 0.953125 0.146797 3.06687 0.146797 5.70312L0.123047 34.2031C0.123047 36.8394 2.2368 38.9531 4.87305 38.9531H42.8731C45.5093 38.9531 47.6231 36.8394 47.6231 34.2031V5.70312C47.6231 3.06687 45.5093 0.953125 42.8731 0.953125ZM42.8731 34.2031H4.87305V19.9531H42.8731V34.2031ZM42.8731 10.4531H4.87305V5.70312H42.8731V10.4531Z" fill="#3E3EFF"/>
            </svg>
            <h3 class="title">{{categories[getCategoryIdByName('billing-support')].title}}</h3>
            <p class="text" v-html="categories[getCategoryIdByName('billing-support')].body"></p>
          </router-link>
        </li>

        <li @click="trackPageClick('account_support')" class="category-boxes__item">
          <router-link class="category-boxes__item__link" :to="{name: 'account-support'}">
            <svg class="icon" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.2402 0.453125C9.47623 0.453125 0.740234 9.18913 0.740234 19.9531C0.740234 30.7171 9.47623 39.4531 20.2402 39.4531C31.0042 39.4531 39.7402 30.7171 39.7402 19.9531C39.7402 9.18913 31.0042 0.453125 20.2402 0.453125ZM10.6267 32.1991C11.4652 30.4441 16.5742 28.7281 20.2402 28.7281C23.9062 28.7281 29.0347 30.4441 29.8537 32.1991C27.2017 34.3051 23.8672 35.5531 20.2402 35.5531C16.6132 35.5531 13.2787 34.3051 10.6267 32.1991ZM32.6422 29.3716C29.8537 25.9786 23.0872 24.8281 20.2402 24.8281C17.3932 24.8281 10.6267 25.9786 7.83823 29.3716C5.84923 26.7586 4.64023 23.5021 4.64023 19.9531C4.64023 11.3536 11.6407 4.35313 20.2402 4.35313C28.8397 4.35313 35.8402 11.3536 35.8402 19.9531C35.8402 23.5021 34.6312 26.7586 32.6422 29.3716ZM20.2402 8.25313C16.4572 8.25313 13.4152 11.2951 13.4152 15.0781C13.4152 18.8611 16.4572 21.9031 20.2402 21.9031C24.0232 21.9031 27.0652 18.8611 27.0652 15.0781C27.0652 11.2951 24.0232 8.25313 20.2402 8.25313ZM20.2402 18.0031C18.6217 18.0031 17.3152 16.6966 17.3152 15.0781C17.3152 13.4596 18.6217 12.1531 20.2402 12.1531C21.8587 12.1531 23.1652 13.4596 23.1652 15.0781C23.1652 16.6966 21.8587 18.0031 20.2402 18.0031Z" fill="#3E3EFF"/>
            </svg>
            <h3 class="title">{{categories[getCategoryIdByName('account-support')].title}}</h3>
            <p class="text" v-html="categories[getCategoryIdByName('account-support')].body"></p>
          </router-link>
        </li>

        <li @click="trackPageClick('technical_support')" class="category-boxes__item">
          <router-link class="category-boxes__item__link" :to="{name: 'technical-support'}">
            <svg class="icon" width="25" height="40" viewBox="0 0 25 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.2701 25.2715H10.7246V28.8169H14.2701V25.2715Z" fill="#3E3EFF"/>
              <path d="M14.2701 11.0894H10.7246V21.7257H14.2701V11.0894Z" fill="#3E3EFF"/>
              <path d="M21.3606 0.470852L3.63335 0.453125C1.68335 0.453125 0.0878906 2.04858 0.0878906 3.99858V35.9077C0.0878906 37.8577 1.68335 39.4531 3.63335 39.4531H21.3606C23.3106 39.4531 24.9061 37.8577 24.9061 35.9077V3.99858C24.9061 2.04858 23.3106 0.470852 21.3606 0.470852ZM21.3606 35.9077H3.63335V34.1349H21.3606V35.9077ZM21.3606 30.5895H3.63335V9.31676H21.3606V30.5895ZM21.3606 5.77131H3.63335V3.99858H21.3606V5.77131Z" fill="#3E3EFF"/>
            </svg>
            <h3 class="title">{{categories[getCategoryIdByName('technical-support')].title}}</h3>
            <p class="text" v-html="categories[getCategoryIdByName('technical-support')].body"></p>
          </router-link>
        </li>
        <li @click="trackPageClick('partners_authors')" class="category-boxes__item">
          <router-link class="category-boxes__item__link" :to="{name: 'partners-authors'}">
            <svg class="icon" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.8047 0.453125C9.04069 0.453125 0.304688 9.18913 0.304688 19.9531C0.304688 30.7171 9.04069 39.4531 19.8047 39.4531C30.5687 39.4531 39.3047 30.7171 39.3047 19.9531C39.3047 9.18913 30.5687 0.453125 19.8047 0.453125ZM19.8047 35.5531C11.2052 35.5531 4.20469 28.5526 4.20469 19.9531C4.20469 11.3536 11.2052 4.35313 19.8047 4.35313C28.4042 4.35313 35.4047 11.3536 35.4047 19.9531C35.4047 28.5526 28.4042 35.5531 19.8047 35.5531Z" fill="#3E3EFF"/>
              <path d="M12.0055 27.7531C14.1594 27.7531 15.9055 26.007 15.9055 23.8531C15.9055 21.6992 14.1594 19.9531 12.0055 19.9531C9.85156 19.9531 8.10547 21.6992 8.10547 23.8531C8.10547 26.007 9.85156 27.7531 12.0055 27.7531Z" fill="#3E3EFF"/>
              <path d="M19.8043 16.0529C21.9582 16.0529 23.7043 14.3068 23.7043 12.1529C23.7043 9.99902 21.9582 8.25293 19.8043 8.25293C17.6504 8.25293 15.9043 9.99902 15.9043 12.1529C15.9043 14.3068 17.6504 16.0529 19.8043 16.0529Z" fill="#3E3EFF"/>
              <path d="M27.6051 27.7531C29.759 27.7531 31.5051 26.007 31.5051 23.8531C31.5051 21.6992 29.759 19.9531 27.6051 19.9531C25.4512 19.9531 23.7051 21.6992 23.7051 23.8531C23.7051 26.007 25.4512 27.7531 27.6051 27.7531Z" fill="#3E3EFF"/>
            </svg>
            <h3 class="title">{{categories[getCategoryIdByName('partners-authors')].title}}</h3>
            <p class="text" v-html="categories[getCategoryIdByName('partners-authors')].body"></p>
          </router-link>
        </li>
      </ul>
    </div>
    <component v-bind:is="footerComponent"></component>
  </div>
</template>

<script>
import { getComponent, getCategoryPageName, getCategoryIdByName, trackPageView, trackPageClick } from '@/utils/common';
export default {
  name: 'home',
  metaInfo() {
    return {
      titleTemplate: `%s | ${this.$t('headerTitle')}`
    };
  },
  created() {
    if (this.$route.query.request) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
    trackPageView('home');
  },
  computed: {
    categories() {
      return this.$store.state.categories;
    },
    articles() {
      return this.$store.state.articles;
    },
    // Getting Component Dynamically & Asynchronously
    headerComponent() {
      return getComponent(this.$store.getters.flowObject, 'header');
    },
    footerComponent() {
      return getComponent(this.$store.getters.flowObject, 'footer');
    }
  },
  methods: {
    getCategoryPageName(catId) {
      return getCategoryPageName(catId, this.$store.getters.flowObject.pages);
    },
    getCategoryIdByName(catName) {
      return getCategoryIdByName(catName);
    },
    hideSuccessMessage() {
      this.$router.push({ path: window.location.pathname });
    },
    trackPageClick(clickName) {
      return trackPageClick(clickName);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/trusted_vpn-design.scss';
.vpn_boxes_section {
  padding: 1rem 0;
  @media (min-width: 992px) {
    padding: 2rem 0;
  }
  @media (min-width: 1301px) {
    padding: 2rem 0 8rem;
  }
}
.category-boxes {
  list-style-type: none;
  font-size: 16px;
  font-weight: 400;
  padding: 0;
  color: #18214F;
  @media (min-width: 600px) {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
  }
  @media (min-width: 1160px) {
    max-width: 1264px;
    margin: 0 auto;
  }
}
.category-boxes__item {
  margin-bottom: 2rem;
  padding: 0 1rem;
}
.category-boxes__item__link {
  text-align: center;
  border: 1px solid transparent;
  text-decoration: none;
  margin: 0 auto;
  line-height: 1.5rem;
  border-radius: 10px;
  padding: 30px 15px 20px;
  display: block;
  height: 100%;
  max-width: 28.3rem;
  background: #fff;
  .title {
    color: #3E3EFF;
    font-weight: 700 !important;
    font-family: 'Montserrat', sans-serif;
    font-style: italic;
    transition: 0.2s linear all;
    line-height: 22px;
    margin: 16px 10px 16px;
    font-size: 18px;
    text-transform: uppercase;
  }
  .icon {
    polygon,
    path {
      transition: 0.2s linear all;
      fill: #3E3EFF;
    }
  }
  .text {
    margin: 15px 0 0;
    font-size: 16px;
    line-height: 1.5;
    color: #18214F;
  }
  &:hover {
    background-color: #3E3EFF;
    color: #fff;
    .title,
    .text {
      color: #fff;
    }
    .icon {
      polygon,
      path {
        fill: #fff;
      }
    }
  }
}
.category-boxes__item {
  width: 100%;
}
@media (min-width: 40em) {
  .category-boxes__item {
    width: calc(50% - 2px);
  }
}
@media (min-width: 992px) {
  .category-boxes__item {
    width: calc(33.3% - 2px);
    margin-bottom: 2em;
  }
}
@media (min-width: 1301px) {
  .category-boxes__item {
    width: calc(20% - 2px);
  }
  .category-boxes__item__link {
    .title {
      min-height: 50px;
    }
  }
}

.notification-inner {
  position: relative;
  margin: 0 auto;
  padding: 0 20px;
  max-width: 980px;
}
.notification {
  border: 1px solid;
  display: table;
  font-family: sans-serif;
  font-size: 12px;
  padding: 10px 15px 15px 15px !important;
  margin: 0px 0px 160px 0px !important;
  transition: height 0.2s;
  width: 100%;
  color: #555;
  text-align: center;
}
.notification-notice {
  background: #dbf3ff;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  z-index: 100;
}

.notification-text {
  padding-left: 15px;
  padding-right: 5px;
  width: 100%;
  display: block;
  text-align: left;
}
.notification-dismiss,
.notification-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  text-decoration: none;
}
.notification-dismiss {
  cursor: pointer;
  right: 0;
}
.notification-icon {
  left: 0;
}
.notification-dismiss::before {
  display: inline-block;
  line-height: 20px;
  text-align: center;
  width: 20px;
}
.notification-dismiss::before {
  color: #000;
  color: initial;
  content: '\2715';
  font-family: sans-serif;
  font-size: 16px;
  opacity: 0.6;
  transition: opacity 100ms ease;
  text-decoration: none !important;
}
.notification-icon::before {
  content: '\2713';
  display: inline-block;
  line-height: 20px;
  text-align: center;
  width: 20px;
  border: 1px solid #b5e0f5;
  border-radius: 50%;
  font-family: 'entypo';
}
</style>
